import { Button } from '@/components/common/button'
import { Note } from '@/components/common/note'
import { InfoIcon } from '@/components/icons/info'
import type { Vault } from '@/types/vault'
import { getProtocolDisplayName } from '@/utils/protocol'
import { formatDecimalToPercentage } from '@vaultsfyi/common/utils'

interface Props {
  vault: Vault
}

export const FluidWithdrawFeeNote = ({ vault }: Props) => {
  const withdrawalFee = vault.fees?.withdrawalFee
  const protocolUrl = vault.protocol.protocolUrl
  const protocolDisplayName = getProtocolDisplayName(vault.protocol)

  return (
    <Note>
      <div className="flex items-center gap-2">
        <InfoIcon />
        <h6 className="font-bold">Withdraw fee</h6>
      </div>
      <p className="text-xs">
        This vault has a {withdrawalFee && formatDecimalToPercentage(withdrawalFee)} fee applied on withdrawals.
        <br />
        Visit{' '}
        {protocolUrl ? (
          <Button variant="default" size="default" className="rounded-full text-xs underline" asChild>
            <a href={protocolUrl} target="_blank" rel="noreferrer">
              {protocolDisplayName}
            </a>
          </Button>
        ) : (
          <>{protocolDisplayName}</>
        )}{' '}
        app for more details.
      </p>
    </Note>
  )
}
